export const formatNumber = (num) => {
  if (!num) {
    num = 0;
  }
  return num.toLocaleString('en-US');
};
